/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_Store_SystemInputs */

const vi_shop_home_kind_store_system = /** @type {(inputs: Shop_Home_Kind_Store_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống cửa hàng`)
};

/**

* @param {Shop_Home_Kind_Store_SystemInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_store_system = /** @type {((inputs?: Shop_Home_Kind_Store_SystemInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_Store_SystemInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_store_system(inputs)
});